import React from 'react';
import { collectionCard as c } from '../../component-classes';
import AdImage from '../ad/AdImage';
import AdLink from '../ad/AdLink';
import type { Image } from '../../types';
import useClickableBlock from '../hooks/useClickableBlock';

type CollectionCardProps = {
    className?: string;
    href: string;
    image: Image;
    name: string;
    onClick?: (event: React.MouseEvent) => void;
    style?: React.CSSProperties;
};

function CollectionCard(props: CollectionCardProps) {
    const { className = '', href, image, name, onClick, style } = props;

    const [blockRef, linkRef] = useClickableBlock();

    return (
        <article
            ref={blockRef}
            className={`${c.card} ${className}`}
            style={style}
        >
            <AdImage
                alt=""
                crop
                aspectClass={c.aspectRatio}
                imageClass={c.image}
                {...image}
            />
            <h3 className={c.heading}>
                <AdLink
                    ref={linkRef}
                    href={href}
                    className={c.link}
                    onClick={onClick}
                >
                    {name}
                </AdLink>
            </h3>
        </article>
    );
}

export default CollectionCard;
